export default __webpack_public_path__ + "static/media/application_process_740.5e9a1eed.svg";